// extracted by mini-css-extract-plugin
export default {"container":"ClemEcosystem_container__VtJ3u","title":"ClemEcosystem_title__K1DOI","img":"ClemEcosystem_img__wPyhT"};